module.exports = __webpack_public_path__ + "img/360.a9a6843e.jpg";